import * as React from "react";
import ScrollToTop from "react-scroll-to-top";
import DefaultFooter from "components/Footer";
import DefaultNavbar from "components/Header";
import MKBox from "components/MKBox";
import { useSelector } from "react-redux";
//Website Sections
import { useTheme } from "@mui/material/styles";
import aboutus2img from "assets/images/other_image/abouts12.png";
import aboutusimg from "assets/images/other_image/aboutus.png";
import Approach from "pages/Website/sections/Approach";
import Product from "pages/Website/sections/Product";
import About from "./sections/About";
import Client from "./sections/Client";
import ContactUS from "./sections/ContactUS";
import Event from "./sections/Event";
import News from "./sections/News";
import CaseStudiesVideo from "./sections/CaseStudiesVideo";
import Service from "./sections/Service";
import Testimonial from "./sections/Testimonial";

// import colorValue from "assets/theme/base/colors";
import { layoutGenerator } from 'react-break';
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

// Routes
import footerRoutes from "footer.routes";
import routes from "routes";

// Images
import animationData from 'assets/json/banner 2.json';
import Lottie from 'react-lottie';
import Partner from "./sections/Partner";
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const images = [
  {
    id: 1,
    imgPath: aboutusimg,
  },
  {
    id: 2,
    imgPath: aboutus2img,
  },
];

const layout = layoutGenerator({
  mobile: 0,
  // phablet: 550,
  // tablet: 768,
  desktop: 992,
});

const OnMobile = layout.is('mobile');
const OnDesktop = layout.is('desktop');
function Website() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  const themeOption = useSelector((state) => state.general.themes);
  console.log("DDD => ", themeOption)
  return (
    <div>
      <ScrollToTop smooth color="#000000" />
      {/* header */}
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <OnMobile>
        <Lottie
          options={defaultOptions}
          minHeight="120vh"
          width="100%"
          style={{
            marginTop: "2.8rem"
          }}
          m={5}
        />

      </OnMobile>

      <OnDesktop>
        <Lottie
          options={defaultOptions}
          minHeight="120vh"
          width="100%"
          m={5}
        />
      </OnDesktop>

      <Approach id="approach" />
      <Product id="product" />
      <OnMobile>
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <div key={step.label}>
              {Math.abs(activeStep - index) <= 2 ? (
                <MKBox component="img" justifyContent="centre" src={step.imgPath} alt="About us Images"
                  height="11rem" width="24.5rem"
                />
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
      </OnMobile>
      <OnDesktop>
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <div key={step.label}>
              {Math.abs(activeStep - index) <= 2 ? (
                <MKBox component="img" justifyContent="centre" src={step.imgPath} alt="About us Images"
                  minHeight="75vh"
                  width="100%"
                />
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
      </OnDesktop>
      <About id="aboutus" />
      <Service id="service" />
      <Client id="client" />
      <Partner id="partner" />
      <Testimonial id="testimonaial" />
      <News id="news" />

      <Event />

      <CaseStudiesVideo/>
      {/* <iframe width="300" height="300"
        src="https://www.youtube.com/embed/hKW7TYwgO-Q?si=w1FgWDtkNuimZHa8"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen></iframe>
      <iframe width="300" height="300"
        src="https://www.youtube.com/embed/TAfAhLM8dNs?si=97Zam5afJL3fSuRE"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen></iframe>
      <iframe width="300" height="300"
        src="https://www.youtube.com/embed/ywVBOPtspcg?si=LOiQuoQWReTQXXDX"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen></iframe> */}
      <ContactUS id="contactus" />

      {/* footer */}
      < MKBox pt={5} px={0} mt={5} >
        <DefaultFooter content={footerRoutes} />
      </MKBox >
    </div>
  );
}

export default Website;
